import { Button } from "@mui/material";
import { XsText } from "Components";
import { useIntl } from "react-intl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export interface ShowMoreButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

const ShowMoreButton = ({ isExpanded, onClick }: ShowMoreButtonProps) => {
  const t = useIntl();

  return (
    <Button
      onClick={onClick}
      sx={{
        alignSelf: "flex-start",
        textTransform: "none",
        color: "var(--gray-500)",
        padding: 0,
        minWidth: "auto",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      <XsText>
        {isExpanded
          ? t.formatMessage({ id: "show_less" })
          : t.formatMessage({ id: "show_more" })}
      </XsText>
      {isExpanded ? (
        <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
      ) : (
        <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
      )}
    </Button>
  );
};

export default ShowMoreButton; 